import RoleProtectedRoute from "@/modules/app/components/role-protected-route"
import MySituationPage from "@/pages/my-situation"
import { UserRole } from "@/shared/entities/users"
import { Navigate, type RouteObject } from "react-router-dom"

const routes: RouteObject = {
  path: "my-situation",
  element: (
    <RoleProtectedRoute redirect="/supervisor" rolesAllowed={[UserRole.STUDENT]}>
      <MySituationPage />
    </RoleProtectedRoute>
  ),
  children: [
    {
      path: "*",
      element: <Navigate to="my-situation" replace />,
    },
  ],
}

export default routes
